// extracted by mini-css-extract-plugin
export default {"emailsNotSupported":"Emails_emailsNotSupported__vT1Hs"};